export const Route = {
  OVERVIEW: '/',
  GETTING_STARTED: '/getting-started',
  SIGN_IN: '/sign-in',
  PRIORITY_IMPACT: '/priority-impact',
  ANALYTICS: '/analytics',
  CHURN_RATE: '/churn-rate',
  PLATFORMS: '/platforms',
  INTEGRATION_STATUS: '/integration-status',
  INTEGRATION: '/integration',
  GAME_PROMOTION: '/game-promotion',
  COST_OPTIMIZATION: '/provider-priorities',
  GAME_COLLECTION: '/game-collection',
  RECOMMENDATIONS: '/recommendations',
  INTEGRATION_GUIDE: '/integration-guide',
  CALCULATOR: '/calculator',
  DEMO_STAND: '/demo-stand',
  NOT_ALLOWED: '/not-allowed',
  NOT_FOUND: '*',
} as const;

export const AnalyticsTab = {
  SECTION_ANALYTICS: 'section-analytics',
  GAME_ANALYTICS: 'game-analytics',
  AB_TESTING: 'ab-testing',
} as const;

export const PlatformsTab = {
  DATA: 'data',
  API_AND_CONNECTION: 'api-and-connection',
  EVENTS: 'events',
} as const;

export const IntegrationTab = {
  DATA: 'data',
  API_AND_CONNECTION: 'api-and-connection',
  EVENTS: 'events',
} as const;

export const GamePromotionTab = {
  PROMOTED: 'promoted',
  EXCLUDED: 'excluded',
} as const;

export const GettingStartedTab = {
  DATA: 'data',
  RECOMMENDATIONS: 'recommendations',
  FEEDBACK: 'feedback',
} as const;
